import script from "./EditCarousel.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditCarousel.vue?vue&type=script&lang=ts&setup=true"

import "./EditCarousel.vue?vue&type=style&index=0&id=cc88db8c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc88db8c"]])

export default __exports__